<template>
  <div v-if="loading" class="text-center mb-3">
    <b-spinner variant="primary"></b-spinner>
  </div>
  <div v-else>
    <b-breadcrumb :items="itemsBread"></b-breadcrumb>
    <div class="d-flex flex-column">
      <h1 style="display: flex;justify-content: center;">Webportal Header</h1>
      <form>
        <div class="d-flex">
          <div class="col-md-6" style="padding-left: 0%;">
            <div class="form-group">
              <label class="footerLabels">Govt Logo</label>
              <div>
                <div class="d-flex justify-content-start">
                  <button class="btn btn-light border border-dark" type="button"
                          @click="showGovtLogoFn">Add
                    Logo
                  </button>
                </div>
                <div v-if="showGovtLogo">
                  <div id="exampleModalFullscreen" aria-labelledby="exampleModalFullscreenLabel" aria-modal="true"
                       class="modal fade show" role="dialog" style="display: block;"
                       tabindex="-1">
                    <div class="modal-dialog modal-xl">
                      <div class="modal-content">
                        <div class="modal-header">
                          <h5 id="exampleModalFullscreenLabel" class="modal-title h4">Add
                            Media
                          </h5>
                          <button aria-label="Close" class="btn-close" data-bs-dismiss="modal"
                                  type="button" @click="showGovtLogo = false"></button>
                        </div>
                        <div class="modal-body" style="height: 70vh; overflow-y: auto;">
                          <select-logo :fetchId="headerData.govt_logo"
                                       @logoImg="getGovtLogo"/>
                        </div>
                        <div class="modal-footer">
                          <button class="btn btn-secondary" data-bs-dismiss="modal"
                                  type="button"
                                  @click="this.showGovtLogo = false">Confirm
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="figure text-center"
                     style="margin-top: 6px;padding: 6px;background-color: rgb(255, 255, 255);border-radius: 4px;
                        border: #000;border-width: 0.5px;border-style: solid;">
                  <img v-if="headerData.govt_logo_url != null" :src="imageBasePath + headerData.govt_logo_url"
                       style="min-height: 100px;max-height: 130px;max-width: 60%;object-fit: contain">
                  <!-- <img src="" class="figure-img img-fluid rounded" style="height: 30px; width: 30px;"
      alt="A generic square placeholder image with rounded corners in a figure."> -->
                  <!-- <figcaption class="figure-caption">Govt Logo</figcaption> -->
                </div>
              </div>
            </div>

          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="footerLabels">Logo</label>
              <div>
                <div class="d-flex justify-content-start">
                  <button class="btn btn-light border border-dark" type="button"
                          @click="showModalLogo = true">Add
                    Logo
                  </button>
                </div>
                <div v-if="showModalLogo">
                  <div id="exampleModalFullscreen" aria-labelledby="exampleModalFullscreenLabel" aria-modal="true"
                       class="modal fade show" role="dialog" style="display: block;"
                       tabindex="-1">
                    <div class="modal-dialog modal-xl">
                      <div class="modal-content">
                        <div class="modal-header">
                          <h5 id="exampleModalFullscreenLabel" class="modal-title h4">Add
                            Media
                          </h5>
                          <button aria-label="Close" class="btn-close" data-bs-dismiss="modal"
                                  type="button" @click="showModalLogo = false"></button>
                        </div>
                        <div class="modal-body" style="height: 70vh; overflow-y: auto;">
                          <select-logo :fetchId="headerData.logo" @logoImg="getLogo"/>
                        </div>
                        <div class="modal-footer">
                          <button class="btn btn-secondary" data-bs-dismiss="modal"
                                  type="button"
                                  @click="this.showModalLogo = false">Confirm
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <figure class="figure text-center"
                        style="margin-top: 6px;padding: 6px;background-color: rgb(255, 255, 255);border-radius: 4px;border: #000;border-width: 0.5px;border-style: solid;">
                  <div v-if="headerData.logo_url != null">
                    <img :src="imageBasePath + headerData.logo_url"
                         style="min-height: 100px;max-height: 130px;max-width: 60%;object-fit: contain">
                  </div>
                </figure>
              </div>
            </div>
          </div>
        </div>


        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class="footerLabels">Banner Title</label>
              <textarea v-model="headerData.banner_title" class="form-control" type="text"></textarea>
            </div>
            <div class="form-group">
              <label class="footerLabels">Banner Content</label>
              <div>
                <div class="form-group mt-1">
                  <div class="d-flex justify-content-between">
                    <div class="d-flex justify-content-start">
                      <button class="btn btn-light border border-dark" type="button"
                              @click="showModalText = true">Add
                        Media
                      </button>
                    </div>
                    <div v-if="showModalText">
                      <div id="exampleModalFullscreen" aria-labelledby="exampleModalFullscreenLabel" aria-modal="true"
                           class="modal fade show" role="dialog"
                           style="display: block;" tabindex="-1">
                        <div class="modal-dialog modal-xl">
                          <div class="modal-content">
                            <div class="modal-header">
                              <h5 id="exampleModalFullscreenLabel" class="modal-title h4">
                                Add
                                Media</h5>
                              <button aria-label="Close" class="btn-close"
                                      data-bs-dismiss="modal" type="button"
                                      @click="showModalText = false"></button>
                            </div>
                            <div class="modal-body" style="height: 70vh; overflow-y: auto;">
                              <show-all-media-component/>
                            </div>
                            <div class="modal-footer">
                              <button class="btn btn-secondary" data-bs-dismiss="modal"
                                      type="button"
                                      @click="showModalText = false">Close
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <Editor :htmlFetch="headerData.banner_content" style="margin-top: 5px;"
                          @htmlData='getHeaderBannerContentBn'></Editor>
                </div>
              </div>
            </div>
            <div class="form-group">
              <label class="footerLabels">Banner About</label>
              <textarea v-model="headerData.banner_about" class="form-control" type="text"></textarea>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="footerLabels">Banner Title(English)</label>
              <textarea v-model="headerData.banner_title_en" class="form-control" type="text"></textarea>
            </div>
            <div class="form-group">
              <label class="footerLabels">Banner Content(English)</label>
              <div>
                <div class="form-group mt-1">
                  <div class="d-flex justify-content-between">
                    <div class="d-flex justify-content-start">
                      <button class="btn btn-light border border-dark" type="button"
                              @click="showModalText = true">Add
                        Media
                      </button>
                    </div>
                    <div v-if="showModalText">
                      <div id="exampleModalFullscreen" aria-labelledby="exampleModalFullscreenLabel" aria-modal="true"
                           class="modal fade show" role="dialog"
                           style="display: block;" tabindex="-1">
                        <div class="modal-dialog modal-xl">
                          <div class="modal-content">
                            <div class="modal-header">
                              <h5 id="exampleModalFullscreenLabel" class="modal-title h4">
                                Add
                                Media</h5>
                              <button aria-label="Close" class="btn-close"
                                      data-bs-dismiss="modal" type="button"
                                      @click="showModalText = false"></button>
                            </div>
                            <div class="modal-body" style="height: 70vh; overflow-y: auto;">
                              <show-all-media-component/>
                            </div>
                            <div class="modal-footer">
                              <button class="btn btn-secondary" data-bs-dismiss="modal"
                                      type="button"
                                      @click="showModalText = false">Close
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <Editor :htmlFetch="headerData.banner_content_en" style="margin-top: 5px;"
                          @htmlData='getHeaderBannerContent'></Editor>
                </div>
              </div>
            </div>
            <div class="form-group">
              <label class="footerLabels">Banner About(English)</label>
              <textarea v-model="headerData.banner_about_en" class="form-control" type="text"></textarea>
            </div>


          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class="footerLabels">Banner Link</label>
              <input v-model="headerData.banner_link" class="form-control" type="text"/>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="footerLabels">Hotline Number</label>
              <input v-model="headerData.hotline" class="form-control" type="text"/>
            </div>
          </div>
        </div>


        <div class="form-group">
          <label class="footerLabels">Slides</label>
          <div class="d-flex justify-content-start">
            <button class="btn btn-light border border-dark" type="button"
                    @click="showModalPartners = true">Add
              Media
            </button>
          </div>
          <div v-if="showModalPartners">
            <div id="exampleModalFullscreen" aria-labelledby="exampleModalFullscreenLabel" aria-modal="true"
                 class="modal fade show" role="dialog" style="display: block;"
                 tabindex="-1">
              <div class="modal-dialog modal-xl">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 id="exampleModalFullscreenLabel" class="modal-title h4">Add Media</h5>
                    <button aria-label="Close" class="btn-close" data-bs-dismiss="modal"
                            type="button" @click="showModalPartners = false"></button>
                  </div>
                  <div class="modal-body" style="height: 70vh; overflow-y: auto;">
                    <selectable-media-component :fetchImageIds="headerData.slideBarImageIds"
                                                @imgList="getImages"/>
                  </div>
                  <div class="modal-footer">
                    <!-- <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
                    @click="saveImage">Ok</button> -->
                    <button class="btn btn-secondary" data-bs-dismiss="modal" type="button"
                            @click="showModalPartners = false">Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <figure class="figure d-flex gap-2 text-center flex-wrap" style="margin-top: 6px;">
            <div v-for="imageInfo in headerData.header_slide_images" :key="imageInfo.image"
                 style="padding: 6px;background-color: rgb(255, 255, 255);border-radius: 4px;width: fit-content;border-radius: 4px;border: #000;border-width: 0.5px;border-style: solid;">
              <img :src="imageBasePath + imageInfo.image_url"
                   style="height: 100px;max-width: 200px;object-fit: contain">
            </div>
          </figure>

        </div>

        <div class="d-flex justify-content-end">
          <button class="btn btn-dark" type="button" @click="sendData">Submit</button>
        </div>
      </form>
    </div>
  </div>
</template>


<script>
import HeaderService from '@/services/header.service';
import showAllMedia from '@/components/Media/ShowAllMedia.vue';
import selectableMedia from '@/components/Media/SelectableMedia.vue';
import selectLogo from '@/components/Media/SelectLogo.vue';
import mediaService from '@/services/media.service';
import Editor from "../../components/Editor";
import Config from '@/config/index';


// import Footer from '../layouts/partial/Footer.vue';
export default {
  name: 'PortalHeader',
  components: {
    "select-logo": selectLogo,
    "show-all-media-component": showAllMedia,
    "selectable-media-component": selectableMedia,
    Editor
  },
  mounted() {
  },
  created() {
    this.imageBasePath = Config.apiFileBasePath;
    this.getHeaderData();
  },
  data() {
    return {
      itemsBread: [
        {
          text: 'Home',
          to: '/dashboard'
        }, {
          text: 'Theme Options',
          href: '#'
        }, {
          text: 'Header Options',
          href: '#'
        }
      ],
      imageBasePath: null,
      showModalPartners: false,
      showModalText: false,
      showGovtLogo: false,
      showModalLogo: false,
      headerData: {
        header_theme_id: 1,
        header_govt_logo_id: null,
        header_logo_id: null,
        hotline: null,
        banner_title: null,
        banner_title_en: null,
        banner_content: null,
        banner_content_en: null,
        banner_about: null,
        banner_about_en: null,
        banner_link: null,
        slideBarImageIds: [],
      },
      loading: false,
    }
  },
  methods: {
    showGovtLogoFn() {
      this.showGovtLogo = true;
    },

    getImages(data) {
      this.headerData.slideBarImageIds = [];
      this.headerData.header_slide_images = [];
      const parsedData = JSON.parse(data);
      parsedData.forEach((element) => {
        this.headerData.header_slide_images.push(
            {
              'image': element[0].media_file_id,
              'image_url': element[0].file_path,
            }
        );
        this.headerData.slideBarImageIds.push(element[0].media_file_id);
      });
    },

    getGovtLogo(data) {
      this.headerData.header_govt_logo_id = data.media_file_id;
      this.headerData.govt_logo = data.media_file_id;
      this.headerData.govt_logo_url = data.file_path;
    },

    getLogo(data) {
      this.headerData.header_logo_id = data.media_file_id;
      this.headerData.logo = data.media_file_id;
      this.headerData.logo_url = data.file_path;
    },

    getHeaderBannerContent(data) {
      this.headerData.banner_content_en = data;
    },
    getHeaderBannerContentBn(data) {
      this.headerData.banner_content = data;
    },

    async getHeaderData() {
      try {
        this.loading = true;
        const response = await HeaderService.getHeader();
        this.loading = false;

        if (response.data) {
          this.headerData.hotline = response.data.hotline;
          this.headerData.banner_title = response.data.banner_title;
          this.headerData.banner_title_en = response.data.banner_title_eng;
          this.headerData.banner_content = response.data.banner_content;
          this.headerData.banner_content_en = response.data.banner_content_eng;
          this.headerData.banner_about = response.data.banner_about;
          this.headerData.banner_about_en = response.data.banner_about_eng;
          this.headerData.banner_link = response.data.banner_link;
          this.headerData.govt_logo_url = response.data.govt_logo_url;
          this.headerData.govt_logo = response.data.govt_logo;
          this.headerData.logo_url = response.data.logo_url;
          this.headerData.logo = response.data.logo;
          this.headerData.header_slide_images = response.data.header_slide_images;
          this.headerData.header_govt_logo_id = this.headerData.govt_logo;
          this.headerData.header_logo_id = this.headerData.logo;


          this.headerData.slideBarImageIds = [];
          this.headerData.header_slide_images.forEach((element) => {
            this.headerData.slideBarImageIds.push(element.image);
          });
        }
      } catch (error) {
        this.loading = false;
      }

    },
    clearData() {
      this.showModalPartners = false;
      this.showModalText = false;
      this.showGovtLogo = false;
      this.showModalLogo = false;
    },
    async getLogoFromId(id) {
      const logo = await mediaService.getOneMedia(id);
      return logo.data;
    },

    showNotification(type, message) {
      this.$notify({
        type: type,
        title: 'Header',
        text: message,
      });
    },
    async sendData() {
      try {
        var slideImageList = [];
        for (let index = 0; index < this.headerData.slideBarImageIds.length; index++) {
          slideImageList.push(
              {
                "id": this.headerData.slideBarImageIds[index],
              }
          );
        }
        this.headerData.slide_bar_image_id_list = slideImageList;
        this.loading = true;
        const response = await HeaderService.updateHeader(this.headerData);
        this.loading = false;

        if (response.data) {
          this.showNotification('success', response.data.message);
          this.clearData();
          await this.getHeaderData();
        } else {
          this.showNotification('error', response.data.message);
        }
      } catch (error) {
        this.loading = false;
      }
    }
  }
}


</script>

<style scoped>
.footerLabels {
  font-weight: 700;
  margin-top: 5px;
}
</style>
